import { ItemFilter } from 'services/useMyItems';

import { MyActivityHotDealsPage } from './MyActivityHotDealsPage';

export const MyActivityDonatedPage = () => <MyActivityHotDealsPage selectedFilter={ItemFilter.DONATED} />;
